import React from 'react';
import { FlexRow, FlexCol } from './generic/Containers';
import { BCHeader4, Body1 } from './generic/BCHeaders';
import { BCIcon, ICONS } from './generic/BCIcons';
import '../css/SuccessNotification.css';

interface SuccessNotificationProps {
    show: boolean;
    onClose: () => void;
}

export const SuccessNotification: React.FC<SuccessNotificationProps> = ({ show, onClose }) => {
    if (!show) return null;

    return (
        <div className="success-notification-overlay">
            <FlexCol 
                className="success-notification-card"
                gap={1}
                padding={2}
                borderRadius={1}
                align="center"
            >
                <FlexRow justify="space-between" widthPercent={100}>
                    <div style={{ width: '24px' }} /> {/* Spacer for center alignment */}
                    <BCIcon 
                        icon={ICONS.CHECKMARK_CIRCLE} 
                        style={{ fontSize: '2rem', color: '#22c55e' }}
                    />
                    <BCIcon 
                        icon={ICONS.CLOSE} 
                        onClick={onClose}
                        style={{ fontSize: '1.2rem', cursor: 'pointer', color: '#64748b' }}
                    />
                </FlexRow>
                
                <FlexCol gap={0.5} align="center">
                    <BCHeader4 text="Welcome to Premium! 🎉" textAlign="center" />
                    <Body1 
                        text="Your premium access is now active. Enjoy all the exclusive content!"
                        textAlign="center"
                    />
                </FlexCol>
            </FlexCol>
        </div>
    );
}; 